export default __webpack_public_path__ + "static/media/Fredoka-Regular.11ed755d.ttf";